import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';

export const VideoSection = () => {
  const { language } = useLanguage();

  // Extract video ID from YouTube URL
  const videoId = 'QKgdese-oJo';

  return (
    <section id="video" className="relative py-20 lg:py-28 bg-white overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-[#0D9488]/3 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#F0FDFA] rounded-full blur-3xl" />

      <div className="relative max-w-6xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="inline-block text-sm font-semibold text-[#0D9488] tracking-[0.2em] uppercase mb-4">
            {language === 'en' ? 'Experience' : 'Experiencia'}
          </span>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-[#0C4A6E] mb-4">
            {language === 'en' ? 'Watch Our Story' : 'Mira Nuestra Historia'}
          </h2>
          <p className="text-lg text-[#64748B] max-w-2xl mx-auto">
            {language === 'en' 
              ? 'Discover the passion behind our authentic Sinaloa mariscos and sushi'
              : 'Descubre la pasión detrás de nuestros auténticos mariscos y sushi de Sinaloa'}
          </p>
        </motion.div>

        {/* Video Container */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-4xl mx-auto"
        >
          <div className="relative bg-[#0C4A6E] rounded-3xl overflow-hidden shadow-2xl shadow-[#0C4A6E]/20">
            {/* Video wrapper with 16:9 aspect ratio */}
            <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
              <iframe
                className="absolute inset-0 w-full h-full"
                src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&playsinline=1`}
                title={language === 'en' ? "Cristian's Baja Salada Restaurant Video" : "Video del Restaurante Cristian's Baja Salada"}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                loading="lazy"
              />
            </div>
          </div>

          {/* Video caption */}
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.4 }}
            className="text-center mt-6 text-[#94A3B8] text-sm"
          >
            {language === 'en' 
              ? "Cristian's Baja Salada - Authentic Sinaloa Flavors in Los Cabos"
              : "Cristian's Baja Salada - Sabores Auténticos de Sinaloa en Los Cabos"}
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};
